import { PaymentService } from '@app/_services/payment.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { CommonUtility } from '@app/_modules/commonUtility';
import { HttpEventType } from '@angular/common/http';
import { saveAs } from 'file-saver';
@Component({
  selector: 'app-capture-response',
  templateUrl: './capture-response.component.html',
  styleUrls: ['./capture-response.component.less']
})
export class CaptureResponseComponent implements OnInit {
receiptData:any;
failedPayment:boolean;
commonUtility:CommonUtility;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private paymentService:PaymentService
    )
    {
      this.failedPayment =false;
      this.commonUtility = paymentService.commonUtility;
      this.route.queryParams.subscribe(params => {
        console.log('params: '+JSON.stringify(params));
        if(params.payment_status === 'FAILED')
          {this.failedPayment = true;}
          this.receiptData = params;

    });
   }
   redirectHome()
   {
     this.router.navigate(['/']);
   }
   downloadIpsrTxnReceipt()
   {
     var req={
      "transactionId":this.receiptData.transaction_id,
      "id":this.receiptData.id,
     }
     console.log('req :');
     console.log(req );
     this.paymentService.downloadIpsrTxnReceipt(req).subscribe((res:any)=>{
      console.log(res);
      let fileName = 'Transaction-receipt-'+this.receiptData.transaction_id;
      const fileContent = res.body;
      const blob = new Blob([fileContent], { type: 'application/pdf' });
      saveAs(blob, fileName);

    });
    }
  ngOnInit(): void {

  }

}
